import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbRestore } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { useUsersRestoreInfo, useUsersTableActions } from "@/stores/use-users-table";
import { UserType } from "@/types/user.types";

import UserRestoreDialogForm from "./UserRestoreDialogForm";

function UserRestoreDialog() {
    const { t } = useTranslation();
    const restoreInfo = useUsersRestoreInfo();
    const { updateRestoreInfo } = useUsersTableActions();
    const onClose = () => {
        updateRestoreInfo();
    };
    return (
        <CommonPopup
            title={t("buttons.updateUserRestore")}
            icon={TbRestore}
            open={!!restoreInfo}
            size="sm"
            onClose={onClose}
        >
            <>
                <Alert severity="info">Kullanıcıyı geri yüklemek istediğinizden emin misiniz?</Alert>
                {restoreInfo && restoreInfo.userType === UserType.DRIVER && !restoreInfo.identityNo && (
                    <Alert severity="info">
                        Kullanıcı T.C Kimlik numarası sistemimizde bulunmadığından dolayo kullanıcının T.C Kimlik
                        numarasını girmeniz gerekmektedir.
                    </Alert>
                )}

                <UserRestoreDialogForm />
            </>
        </CommonPopup>
    );
}

export default UserRestoreDialog;
